import type { Template } from "@/types";

export const PO_06_H4_V2: Template[] = [
{
    id: "po-06-h4v2-01",
    name: "PO 01 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 53, y: 166, width: 515, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 576, width: 167, height: 114, rotation: 0, imageRotation: 0 },
            { id: "3", x: 228, y: 576, width: 167, height: 114, rotation: 0, imageRotation: 0 },
            { id: "4", x: 403, y: 576, width: 166, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 663, y: 232, width: 246, height: 386, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 232, width: 246, height: 386, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h4v2-02",
    name: "PO 02 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 58, y: 172, width: 504, height: 326, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 58, y: 506, width: 248, height: 174, rotation: 0, imageRotation: 0 },
        { id: "3", x: 314, y: 506, width: 248, height: 174, rotation: 0, imageRotation: 0 },
        { id: "4", x: 715, y: 171, width: 396, height: 251, rotation: 0, imageRotation: 0 },
        { id: "5", x: 715, y: 430, width: 194, height: 250, rotation: 0, imageRotation: 0 },
        { id: "6", x: 917, y: 430, width: 194, height: 250, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-03",
    name: "PO 03 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 81, y: 164, width: 206, height: 329, rotation: 0, imageRotation: 0 },
        { id: "2", x: 81, y: 501, width: 124, height: 185, rotation: 0, imageRotation: 0 },
        { id: "3", x: 213, y: 501, width: 316, height: 185, rotation: 0, imageRotation: 0 },
        { id: "4", x: 295, y: 164, width: 234, height: 161, rotation: 0, imageRotation: 0 },
        { id: "5", x: 295, y: 333, width: 234, height: 160, rotation: 0, imageRotation: 0 },
        { id: "6", x: 665, y: 252, width: 495, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-04",
    name: "PO 04 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 54, y: 254, width: 503, height: 342, rotation: 0, imageRotation: 0 },
        { id: "2", x: 653, y: 163, width: 254, height: 403, rotation: 0, imageRotation: 0 },
        { id: "3", x: 915, y: 163, width: 254, height: 403, rotation: 0, imageRotation: 0 },
        { id: "4", x: 653, y: 574, width: 167, height: 114, rotation: 0, imageRotation: 0 },
        { id: "5", x: 828, y: 574, width: 166, height: 114, rotation: 0, imageRotation: 0 },
        { id: "6", x: 1002, y: 574, width: 166, height: 114, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-05",
    name: "PO 05 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 54, y: 177, width: 314, height: 496, rotation: 0, imageRotation: 0 },
        { id: "2", x: 376, y: 429, width: 175, height: 244, rotation: 0, imageRotation: 0 },
        { id: "3", x: 376, y: 177, width: 175, height: 118, rotation: 0, imageRotation: 0 },
        { id: "4", x: 376, y: 303, width: 175, height: 118, rotation: 0, imageRotation: 0 },
        { id: "5", x: 735, y: 178, width: 355, height: 244, rotation: 0, imageRotation: 0 },
        { id: "6", x: 735, y: 430, width: 355, height: 243, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-06",
    name: "PO 06 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_06.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 62, y: 256, width: 218, height: 337, rotation: 0, imageRotation: 0 },
        { id: "2", x: 288, y: 256, width: 155, height: 107, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 371, width: 155, height: 107, rotation: 0, imageRotation: 0 },
        { id: "4", x: 288, y: 486, width: 155, height: 107, rotation: 0, imageRotation: 0 },
        { id: "5", x: 451, y: 256, width: 217, height: 337, rotation: 0, imageRotation: 0 },
        { id: "6", x: 676, y: 256, width: 480, height: 337, rotation: 0, imageRotation: 0 }      
    ],
},

{
    id: "po-06-h4v2-07",
    name: "PO 07 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 61, y: 163, width: 662, height: 525, rotation: 0, imageRotation: 0 },
        { id: "2", x: 731, y: 163, width: 171, height: 259, rotation: 0, imageRotation: 0 },
        { id: "3", x: 731, y: 430, width: 171, height: 258, rotation: 0, imageRotation: 0 },
        { id: "4", x: 910, y: 163, width: 245, height: 170, rotation: 0, imageRotation: 0 },
        { id: "5", x: 910, y: 341, width: 245, height: 170, rotation: 0, imageRotation: 0 },
        { id: "6", x: 910, y: 519, width: 245, height: 169, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-08",
    name: "PO 08 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 204, width: 306, height: 218, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 0, y: 430, width: 306, height: 218, rotation: 0, imageRotation: 0 },
        { id: "3", x: 314, y: 204, width: 306, height: 218, rotation: 0, imageRotation: 0 },
        { id: "4", x: 314, y: 430, width: 306, height: 218, rotation: 0, imageRotation: 0 },
        { id: "5", x: 628, y: 204, width: 290, height: 444, rotation: 0, imageRotation: 0 },
        { id: "6", x: 926, y: 204, width: 290, height: 444, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-09",
    name: "PO 09 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 75, y: 109, width: 208, height: 313, rotation: 0, imageRotation: 0 },
        { id: "2", x: 291, y: 109, width: 422, height: 313, rotation: 0, imageRotation: 0 },
        { id: "3", x: 721, y: 109, width: 423, height: 313, rotation: 0, imageRotation: 0 },
        { id: "4", x: 75, y: 430, width: 423, height: 313, rotation: 0, imageRotation: 0 },
        { id: "5", x: 506, y: 430, width: 422, height: 313, rotation: 0, imageRotation: 0 },
        { id: "6", x: 936, y: 430, width: 208, height: 313, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h4v2-10",
    name: "PO 10 - H4V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h4_v2_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 84, y: 150, width: 394, height: 272, rotation: 0, imageRotation: 0 },
        { id: "2", x: 84, y: 430, width: 394, height: 271, rotation: 0, imageRotation: 0 },
        { id: "3", x: 486, y: 150, width: 290, height: 445, rotation: 0, imageRotation: 0 },
        { id: "4", x: 784, y: 150, width: 350, height: 551, rotation: 0, imageRotation: 0 },     
        { id: "5", x: 486, y: 603, width: 141, height: 98, rotation: 0, imageRotation: 0 },
        { id: "6", x: 635, y: 603, width: 141, height: 98, rotation: 0, imageRotation: 0 }
    ],
}
];